// THIRD-PARTY-NOTICES.md -> blocks for the licences page (src/pages/Licences.jsx). Only what that file uses: headings, paragraphs,
// bullet lists (with wrapped lines), tables.
// Markdown -> blocks: { h, level, text } | { p, text } | { ul, items } | { table, head, rows }
export function parseNotices(md) {
  const lines = String(md || '').replace(/\r/g, '').split('\n'), out = []
  for (let i = 0; i < lines.length; i++) {
    const l = lines[i]
    if (!l.trim()) continue
    const h = l.match(/^(#{1,3})\s+(.*)$/)
    if (h) { out.push({ h: true, level: h[1].length, text: h[2] }); continue }
    if (l.trim().startsWith('|')) {
      const rows = []
      while (i < lines.length && lines[i].trim().startsWith('|')) { rows.push(lines[i].trim().replace(/^\||\|$/g, '').split('|').map(c => c.trim())); i++ }
      i--
      out.push({ table: true, head: rows[0], rows: rows.slice(1).filter(r => !r.every(c => /^:?-+:?$/.test(c))) })
      continue
    }
    if (/^\s*-\s+/.test(l)) {
      const items = []
      while (i < lines.length && (/^\s*-\s+/.test(lines[i]) || (/^\s{2,}\S/.test(lines[i]) && items.length))) {
        if (/^\s*-\s+/.test(lines[i])) items.push(lines[i].replace(/^\s*-\s+/, '')); else items[items.length - 1] += ' ' + lines[i].trim()
        i++
      }
      i--
      out.push({ ul: true, items })
      continue
    }
    let text = l.trim()
    while (i + 1 < lines.length && lines[i + 1].trim() && !/^(#|\||\s*-\s)/.test(lines[i + 1])) text += ' ' + lines[++i].trim()
    out.push({ p: true, text })
  }
  return out
}
